<!-- Scene Viewport -->
<script lang="ts">
  import { sceneState } from '../stores/sceneEditorStore';

  // Все взаимодействия теперь обрабатываются в SceneEditorScene
  // Здесь только UI overlay
</script>

<div class="scene-viewport relative w-full h-full overflow-hidden">
  <!-- Viewport Info Overlay -->
  <div
    class="absolute top-4 left-4 bg-black/50 backdrop-blur-sm rounded-lg p-3 text-white text-sm pointer-events-none"
  >
    <div class="space-y-1">
      <div>Viewport: {$sceneState.viewport.x.toFixed(0)}, {$sceneState.viewport.y.toFixed(0)}</div>
      <div>Zoom: {($sceneState.viewport.zoom * 100).toFixed(0)}%</div>
      <div>Objects: {Object.keys($sceneState.objects).length}</div>
    </div>
  </div>

  <!-- Grid Info -->
  {#if $sceneState.grid.enabled}
    <div
      class="absolute bottom-4 left-4 bg-black/50 backdrop-blur-sm rounded-lg p-2 text-white text-xs pointer-events-none"
    >
      Grid: {$sceneState.grid.size}px
    </div>
  {/if}
</div>
